module.exports = __webpack_public_path__ + "img/nc_eski.d272a1cd.png";